/**
 * Menü seed olmadan DMS route'larını routeList'e ekler.
 * Admin sayfaları yalnızca admin (veya dev bypass) ile eklenir.
 */
export const DMS_ADMIN_ROUTE_PATHS = [
  "/documents/categories",
  "/documents/system",
  "/documents/project-tracking",
  "/documents-project-notify",
];

export const DMS_PROJECT_ROUTE_PATHS = ["/my-documents"];

export const DMS_ROUTE_PATHS = [
  ...DMS_ADMIN_ROUTE_PATHS,
  ...DMS_PROJECT_ROUTE_PATHS,
];

export const ensureDmsRoutes = (routeList, allRoutes, { isAdmin } = {}) => {
  const next = Array.isArray(routeList) ? [...routeList] : [];
  if (!Array.isArray(allRoutes)) return next;

  const paths = isAdmin ? DMS_ROUTE_PATHS : DMS_PROJECT_ROUTE_PATHS;

  paths.forEach((path) => {
    const route = allRoutes.find((item) => item && item.path === path);
    if (route && !next.some((item) => item.path === route.path)) {
      next.push(route);
    }
  });
  return next;
};

const collectUrls = (items, acc = []) => {
  if (!Array.isArray(items)) return acc;
  items.forEach((item) => {
    if (item && item.url) acc.push(String(item.url).toLowerCase());
    if (item && item.children) collectUrls(item.children, acc);
  });
  return acc;
};

export const menuHasMyDocuments = (items) =>
  collectUrls(items).some(
    (url) =>
      url.indexOf("my-documents") !== -1 || url.indexOf("belgelerim") !== -1
  );

export const menuHasDmsAdmin = (items) =>
  collectUrls(items).some(
    (url) =>
      url.indexOf("/documents/categories") !== -1 ||
      url.indexOf("/documents/system") !== -1 ||
      url.indexOf("/documents/project-tracking") !== -1 ||
      url.indexOf("documents-categories") !== -1 ||
      url.indexOf("documents-system") !== -1 ||
      url.indexOf("documents-project-tracking") !== -1
  );

export const menuHasDms = (items) =>
  menuHasMyDocuments(items) || menuHasDmsAdmin(items);

export const DMS_ADMIN_MENU = {
  name: "Döküman Yönetimi",
  url: "/documents/categories",
  icon: "fa fa-folder-open-o",
  children: [
    {
      name: "Döküman Kategorileri",
      url: "/documents/categories",
      icon: "fa fa-sitemap",
    },
    {
      name: "Sistem Dökümanları",
      url: "/documents/system",
      icon: "fa fa-file-text-o",
    },
    {
      name: "Proje Döküman Takibi",
      url: "/documents/project-tracking",
      icon: "fa fa-list-alt",
    },
  ],
};

export const DMS_MY_DOCUMENTS_MENU = {
  name: "Belgelerim",
  url: "/my-documents",
  icon: "fa fa-id-card-o",
};

export const isAllowedWhenLockedUrl = (url) => {
  const u = String(url || "").toLowerCase();
  return (
    u === "/home" ||
    u === "/" ||
    u.indexOf("my-documents") !== -1 ||
    u.indexOf("selectproject") !== -1 ||
    u.indexOf("profile") !== -1
  );
};

export const filterMenuWhenLocked = (items) => {
  if (!Array.isArray(items)) return [];
  return items
    .map((item) => {
      const children = filterMenuWhenLocked(item.children || []);
      const selfOk = isAllowedWhenLockedUrl(item.url);
      if (selfOk || children.length > 0) {
        return {
          ...item,
          children: children.length ? children : undefined,
        };
      }
      return null;
    })
    .filter(Boolean);
};
